export default "__VITE_ASSET__ccf91cb4__"